import ReviewsIcon from '@mui/icons-material/Reviews';
import { Box, Card, Chip, Tooltip, Typography } from '@mui/material';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import config from '../../../config';

function DashboardStatListCard({ countList, type, inst = "kurul" }) {
    const navigate = useNavigate();
    const [displayText, setDisplayText] = useState("");
    const [title, setTitle] = useState("");
    const [tooltipTitle, setTooltipTitle] = useState("");
    const [color, setColor] = useState("");
    const [otherColor, setOtherColor] = useState("");

    useEffect(() => {
        const cardConfig = config.dashboardCarsInfo.find(card => card.name === type);
        if (cardConfig) {
            setTitle(cardConfig.title);
            setTooltipTitle(cardConfig.tooltipTitle);
            setColor(cardConfig.color);
            setOtherColor(cardConfig.otherColor);
        }

        const countMapping = {
            attented: countList?.userFinishedMeetingCount,
            ongoing: countList?.userOngoingMeetingCount,
            review: countList?.reviewMeetingCount,
            vote: countList?.voteMeetingCount,
            video: countList?.videoMeetingCount,
            allFinish: countList?.allFinishedMeetingCount,
            allOngoing: countList?.allOngoingMeetingCount,
            admin: countList?.userAdminMeetingCount,
        };

        setDisplayText(`${countMapping[type] || 0} Toplantı`);
    }, [type, countList]);

    const countMapping = {
        attented: countList?.userFinishedMeetingCount,
        ongoing: countList?.userOngoingMeetingCount,
        review: countList?.reviewMeetingCount,
        vote: countList?.voteMeetingCount,
        video: countList?.videoMeetingCount,
        allFinish: countList?.allFinishedMeetingCount,
        allOngoing: countList?.allOngoingMeetingCount,
        admin: countList?.userAdminMeetingCount,
    };

    const currentCount = countMapping[type] || 0;

    const handleCardClick = () => {
        if (currentCount === 0) {
            return;
        }
        if (type === "attented") {
            navigate('/attendedMeetings/attented');
        } else if (type === "ongoing") {
            navigate('/attendedMeetings/ongoing');
        } else if (inst === 'yk') {
            if (
                type === "review" ||
                type === "vote" ||
                type === "video" ||
                type === "allFinish" ||
                type === "allOngoing" ||
                type === "admin"
            ) {
                navigate('/managementMeeting/1/' + type);
            }
        } else if (inst === 'kurul') {
            if (
                type === "review" ||
                type === "vote" ||
                type === "video" ||
                type === "allFinish" ||
                type === "allOngoing" ||
                type === "admin"
            ) {
                navigate('/managementMeeting/3/' + type);
            }
        }
    };


    const FONT_SIZE = '10px';

    return (
        <Card
            onClick={handleCardClick}
            sx={{
                opacity: currentCount > 0 ? 1 : 0.6,
                backgroundColor: color,
                height: 130,
                cursor: currentCount === 0 ? 'default' : 'pointer',

                boxShadow: 2,
                borderRadius: 3
            }}
        >
            <Tooltip
                title={
                    currentCount !== 0
                        ? `${tooltipTitle} listelemek için dokunun lütfen`
                        : "Toplantı bulunmamaktadır"
                }
                arrow
                sx={{ m: 0, p: 0, cursor: 'pointer' }}
            >
                <Box sx={{ marginTop: '5px', p: 1, display: "flex", flexDirection: "column" }}>
                    {/* İkon ve Chip tek satırda; ikon en solda, Chip en sağda */}
                    <Box
                        sx={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            width: "100%",

                        }}
                    >
                        <ReviewsIcon style={{ color: otherColor, fontSize: '20px' }} />
                        <Chip
                            size="small"
                            label={displayText}
                            sx={{ bgcolor: otherColor, color: '#ffffff', fontSize: FONT_SIZE }}
                        />
                    </Box>
                    <Box sx={{ width: "100%" }}>
                        <Typography
                            color="#5b5b5b"
                            variant="h6"
                            mb={0}
                            sx={{ textAlign: 'center', fontSize: FONT_SIZE, m: 3, p: 0 }}
                        >
                            {title}
                        </Typography>
                    </Box>
                </Box>
            </Tooltip>
        </Card>
    );
}

export default DashboardStatListCard;